<template>
  <div class="page page-add">
    <div class="page-container">
      <div class="page-title">{{ noticeId ? '编辑' : '新增' }}通知</div>
      <div class="w1200">
        <div class="panel">
          <a-form-model ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" class="form-class">
            <div class="panel-body">
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      通知标题
                    </span>
                    <a-input placeholder="标题" allowClear v-model="form.title" ref="title" />
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      通知范围
                    </span>
                    <div style="width: 660px">
                      <a-checkbox-group v-model="form.roles" class="v-mt-sm">
                        <a-row :gutter="[8, 8]">
                          <a-col span="6" v-for="item in userRoles" :key="item.value">
                            <a-checkbox :value="item.value">{{ item.label }}</a-checkbox>
                          </a-col>
                        </a-row>
                      </a-checkbox-group>
                    </div>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      发布时间
                    </span>
                    <a-date-picker ref="publishTime" v-model="form.publishTime" placeholder="选择日期" style="width: 160px" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      通知内容
                    </span>
                    <editor v-model="form.content" />
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false">
                    <span slot="label">通知附件</span>
                    <a-upload-dragger
                      :action="`${baseURL}/file/upload`"
                      :data="{
                        params: JSON.stringify({ fileMark, fileBelongId: noticeId, fileSign: 'NOTICE' }),
                      }"
                      :file-list="files"
                      :before-upload="beforeUploadFile"
                      @preview="handlePreviewFile"
                      @change="handleUploadChange"
                      accept=".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx, .png, .jpg, .jpeg, .gif, .mp4, .flv, .mov, .avi, .rmvb, .3gp, .wma, .zip, .rar"
                      ref="files"
                    >
                      <p class="ant-upload-drag-icon">
                        <a-icon type="upload" />
                      </p>
                      <p class="ant-upload-text">点击选择或拖拽文件至此区域上传</p>
                    </a-upload-dragger>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </div>
          </a-form-model>
        </div>

        <a-affix :offset-bottom="10" :target="() => this.$refs.container">
          <div class="text-center v-mt-sm">
            <a-space>
              <a-button icon="save" type="indigo" @click="handleConfirm(0)">保存初稿</a-button>
              <a-button icon="check" type="primary" @click="handleConfirm(1)">保存并发布通知</a-button>
              <a-button icon="left" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
      </div>
    </div>
  </div>
</template>

<script>
import { saveNotice, getNotice } from '@/api/system/notice'
import Editor from './editor'
const form = {
  publishTime: undefined,
  roles: ['U01', 'U02', 'U03', 'U04', 'U05', 'U06'],
  title: '',
  content: '',
}

export default {
  components: {
    Editor,
  },
  data() {
    return {
      noticeId: undefined,
      form: {
        ...form,
        publishTime: this.$moment().format('YYYY-MM-DD'),
      },
      fileMark: this.$utils.uuid(),
      files: [],
    }
  },
  computed: {
    userRoles: vm => vm.$store.state.app.userRoles,
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.noticeId = +id
        this.loadNotice()
      }
    },
    loadNotice() {
      getNotice(this.noticeId).then(({ data }) => {
        if (data.success) {
          let { title, content, publishTime, roles = '', files } = data.result
          this.form = {
            title,
            content,
            publishTime,
            roles: roles.split(','),
          }
          this.files = files.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'NOTICE',
            belongId: file.noticeId,
            ...file,
            url: `${this.baseURL}/file/view?id=${file.fileId}&belongId=${file.noticeId}&fileSign=NOTICE`,
          }))
        }
      })
    },
    handleUploadChange(info) {
      this.files = this.handleUploadFile(info, -1)
    },
    handleConfirm(nextStep) {
      let { publishTime, title } = this.form
      // let { expertList, voteList } = this
      this.$message.destroy()
      if (title.trim() === '') {
        this.$message.warning('请输入通知标题')
        this.$refs.title.focus()
        return
      }
      if (!publishTime) {
        this.$message.warning('请选择发布时间')
        this.$refs.publishTime.focus()
        return
      }
      this.$confirm({
        title: nextStep ? '确认保存并发布通知？' : '确认保存通知草稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      this.$message.destroy()
      let { title, publishTime, content, roles } = this.form
      let { noticeId, files, fileMark } = this
      let params = {
        noticeId,
        title: title.trim(),
        content,
        publishTime,
        roles: roles.join(','),
        fileIds: files.map(d => d.fileId),
        fileMark,
        nextStep,
      }
      saveNotice(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.noticeId = data.result
            this.$router.go(-1)
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(() => {
          this.$message.error('操作失败')
        })
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus">
.form-class{
    background-color: #f4f4fa;
    padding: 20px;
    border-radius: 3px;
    margin-bottom: 20px;
}
</style>
